import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
// import Nakad from "../../Graphics/Nakad_Blue.png";
// import Nakad from "../../Graphics/nakad-logo.png";
import Nakad from "../../Graphics/NAKAD_FINAL (1).png";
import { userContext } from "../Contexts/userContext";
import Register from "../Register/Register";
import illustration from "./../../Graphics/illustration.svg";

import Grid from "@mui/material/Grid";

import { Box } from "@mui/material";
import { ActorTypes, FrontendActor } from "src/entity/models/FrontendActor";
import "./Login.scss";

const eye = <FontAwesomeIcon icon={faEye as IconProp} />;

const Login = () => {
  const { setActor } = useContext(userContext);
  const history = useHistory();
  const location = useLocation();
  const [form, setForm] = useState({
    companyid: "",
    username: "",
    password: "",
  });

  const [passwordShown, setPasswordShown] = useState(false);
  const [showSignUpForm, setShowSignUpForm] = useState(false);

  const update = (event: React.ChangeEvent<HTMLInputElement>) =>
    setForm({ ...form, [event.target.name]: event.target.value });

  useEffect(() => {
    if (location.state !== undefined && (location.state as any).alert === "true") {
      document.getElementById("flash-msg").style.display = "block";
      document.getElementById("msg").innerHTML = "Please Login to access Action page";
    }
  }, [location]);

  useEffect(() => {
    axios.get<{ result: { user: FrontendActor } }>("/auth/check").then((response) => {
      if (response.status === 200) {
        setActor(response.data.result.user);
        redirect(response.data.result.user, history);
      }
    });
    // eslint-disable-next-line
  }, []);

  const loginUser = async (event: any) => {
    event.preventDefault();
    for (let RETRY_COUNT = 3; RETRY_COUNT > 0; RETRY_COUNT--) {
      await axios
        .post<{ result: { user: FrontendActor } }>("/auth/login", {
          username: form.username,
          password: form.password,
        })
        .then((response) => {
          setActor(response.data.result.user);

          if (response.status === 200) {
            console.log("RETRY_COUNT 200", RETRY_COUNT);
            RETRY_COUNT = 0;
            redirect(response.data.result.user, history);
          } else if (response.status === 401) {
            console.log("RETRY_COUNT 401 ", RETRY_COUNT);
            document.getElementById("flash-msg").style.display = "block";
            document.getElementById("msg").innerHTML = "Wrong Credential ! Please Try Again";
          }
        })
        .catch((error) => {
          document.getElementById("flash-msg").style.display = "block";
          document.getElementById("msg").innerHTML = "Login Failed! Please Try Again";
          console.log("RETRY_COUNT error", RETRY_COUNT);
          console.log("error", error?.response);
        });
    }
  };

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const closeflash = () => {
    document.getElementById("flash-msg").style.display = "none";
  };

  return (
    <Box className=" login-page">
      <Grid container={true}>
        <Grid item={true} sm={12} md={5} className="login-left">
          <img src={illustration} alt="" />
        </Grid>

        {showSignUpForm ? (
          <Grid item={true} sm={12} md={7} className="login-right">
            <Grid item={true} sm={12} md={12}>
              <Register setShowSignUpForm={setShowSignUpForm} />
              <p className="contact">
                Reach us at <a href="mailto:support@nakad.co">support@nakad.co</a>
              </p>
            </Grid>
          </Grid>
        ) : (
          <Grid item={true} sm={12} md={7} className="login-right">
            <div className="login-right-height">
              <div className="login-right-center" style={{ position: "relative" }}>
                <div className="center-box column is-5">
                  <img src={Nakad} alt="" style={{ width: "90%" }} />
                  <p className="enter-info-text">Please enter your user information</p>
                  <div className="notification is-danger" id="flash-msg">
                    <button className="delete" onClick={closeflash} />
                    <p id="msg" />
                  </div>
                  <form onSubmit={loginUser}>
                    <div className="field">
                      <div className="control">
                        <input
                          className="input input-box"
                          type="text"
                          name="username"
                          placeholder="User ID"
                          value={form.username}
                          onChange={update}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <div className="control has-icons-right">
                        <div style={{ display: "flex" }}>
                          <input
                            className="input input-box"
                            type={passwordShown ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            value={form.password}
                            onChange={update}
                            required={true}
                          />
                          <i onClick={togglePasswordVisiblity} id="eye">
                            {eye}
                          </i>
                        </div>
                      </div>
                      <Link className="help has-text-right" to="/reset">
                        Forgot Password?
                      </Link>
                    </div>
                    <div className="buttons">
                      <button type="submit" className="button login-button">
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <p className="contact">
                Reach us at <a href="mailto:support@nakad.co">support@nakad.co</a>
              </p>
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Login;

function redirect(actor: FrontendActor, history: ReturnType<typeof useHistory>) {
  if (actor.actorType === ActorTypes.Admin) {
    history.push("/admin/dashboard");
  } else if (actor.actorType === ActorTypes.Anchor) {
    history.push("/anchor/dashboard");
  } else if (actor.actorType === ActorTypes.Vendor) {
    history.push("/vendor/dashboard");
  }
}
